<template>
  <base-layout>
    <template v-slot:header>
      <div class="top-title">
        <div class="title">
          <p :class="{ active: isAIFailed}">{{ getResultText() }}</p>
          <p class="topic-list-wrapper" v-if="topicInfo.topic_list && topicInfo.topic_list.length === 1">
            <span v-for="item in topicInfo.topic_list" :key="item.id">命题为：{{ item.title }}</span>
          </p>
           <p class="topic-list-wrapper" v-else>
            <span v-for="(item, index) in topicInfo.topic_list" :key="item.id">命题{{ index+1 }}：{{ item.title }}</span>
          </p>
        </div>
        <div class="btn-requirements sub-title" @click="onClickRequirement">写作要求></div>
      </div>
    </template>
    <Periods :period="activityInfo.period" :activityStatus="activityInfo.activity_status"/>
    <Button :btnConfig="btnConfig"/>
    <template v-slot:footer>
      <CommonProcess/>
    </template>
  </base-layout>
</template>
<script>
import BaseLayout from '../common/baseLayout'
import Periods from '../common/periods'
import Button from '../common/button'
import CommonProcess from '../common/commonProcess'
import { Dialog } from 'vant'
import eventBus from '@/summerCamp/utils/bus'

export default {
  name: 'notRegistered',
  components: {
    BaseLayout,
    Periods,
    Button,
    CommonProcess
  },
  props: {
    activityInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    topicInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    isShowToSubmit: {
      type: Boolean,
      required: true
    },
    isShowRegisteredToStart: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      btnConfigSubmit: {
        btnText: '立即提交作文',
        fn: () => {
          this.$router.push({
            name: 'articleUpload'
          })
          this.$xesLogger.clickMsg({
            params: { clickid: '10.0.7', elemname: '点击上传征文入口' }
          })
        }
      },
      btnConfigToSubmit: {
        btnText: '6月17日可上传作文',
        fn: () => {
          Dialog.alert({
            title: '温馨提示',
            message: '6月17日10:00开启上传作文入口\n请耐心等待',
            theme: 'round-button'
          }).then(() => {
            // on close
          })
          this.$xesLogger.clickMsg({
            params: { clickid: '10.0.7', elemname: '点击上传征文入口' }
          })
        }
      }
    }
  },
  computed: {
    btnConfig() {
      if (this.isShowRegisteredToStart) {
        return this.btnConfigToSubmit
      }
      if (this.isShowToSubmit) {
        return this.btnConfigSubmit
      }
      return ''
    },
    isAIFailed() {
      const { submit_status, process_status } = this.activityInfo
      return +process_status === 1 && +submit_status === 0
    }
  },
  methods: {
    getResultText() {
      return this.isAIFailed ? '审核未通过，请重新提交作文' : '已报名，你在提交作文阶段'
    },
    onClickRequirement() {
      eventBus.$emit('show-writing-requirement')
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  .top-title {
    padding-top: 4px;
    padding-bottom: 26px;
    text-align: center;

    .title {
      height: 72px/2;
      margin-top: 8px;
      font-size: 22px/2;
      font-weight: 400;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 18px;
      text-align: center;
      color: #666;

      > p {
        width: 84%;
        margin: 0 auto;
        overflow: hidden;
        line-height: 18px;
        white-space: nowrap;
        text-overflow: ellipsis;

        &.active {
          color: #ca0808;
        }
      }

      .topic-list-wrapper {
        margin: 2px auto;

        > span:first-child {
          margin-right: 8px;
        }

        > span {
          font-weight: 400;
        }
      }
    }

    .sub-title {
      display: inline-block;
      font-size: 22px/2;
      font-weight: 400;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 30px/2;
      color: #ca0808;
    }

    & /deep/ .btn-wrapper {
      margin-top: 16%;
    }
  }

  .periods-wrapper {
    box-sizing: border-box;
    width: 90%;
    margin: 0 auto;

    ul {
      display: flex;
      overflow-x: auto;
      white-space: nowrap;

      li {
        flex: 1;
      }
    }

    .desc {
      text-align: center;
    }
  }
}
</style>
<style>
.van-dialog__header {
  color: #333 !important;
}
</style>
